import {
  Quote2dMapWorkerInput,
  Quote2dMapWorkerOutput,
} from '@/utilities/quote2dMap';
import { createSingleton } from '../utilities/singleton';
import { useWebWorker, WebWorker } from './useWebWorker';

const Quote2dMapWorker = WebWorker.bind<
  [() => Worker],
  [],
  WebWorker<Quote2dMapWorkerInput, Quote2dMapWorkerOutput>
>(
  WebWorker,
  () => new Worker(new URL('../workers/quote2dMap.worker.ts', import.meta.url))
);

const singleton = createSingleton(
  () => new Quote2dMapWorker(),
  (worker) => worker.terminate()
);

export const useQuote2dMapWorker = (setLoading?: (loading: boolean) => void) => {
  const worker = singleton();
  if (!worker) {
    throw new Error('Failed to get quote2dMap worker instance');
  }
  return useWebWorker(worker, setLoading);
};
